module.exports = __webpack_public_path__ + "img/earring.63155bf0.png";